module.exports = __webpack_public_path__ + "media/images/emblems/Zaeziwil-coat_of_arms-c5733d44ebd9260677f343d63bcfbbde.svg";